import { Component } from '@angular/core';

@Component({
  selector: 'app-step-three',
  imports: [],
  templateUrl: './step-three.html',
  styleUrl: './step-three.scss'
})
export class StepThree {

}
